var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"fulLoader",staticClass:"full-loader",staticStyle:{"display":"none"}},[_c('div',{ref:"backdrop",staticClass:"fade modal-backdrop",staticStyle:{"display":"none"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c09b027a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/custom/mbstalas/dialogs/modalFullLoader.vue
// module id = 1261
// module chunks = 146